import { Card as AntdCard } from "antd"
import cx from "clsx"
import styles from "./index.module.less"

const Card = props => {
  const { className, children, variant, Shadow = true, ...rest } = props

  return (
    <AntdCard
      className={cx(
        className,
        styles.card,
        variant === "gray" && styles.grayed,
        variant === "fill" && styles.filled,
        variant === "gradient" && styles.gradient,
        Shadow && styles.shadowed
      )}
      {...rest}
    >
      {children}
    </AntdCard>
  )
}

export default Card